import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';

import { EmojiPlaceholder } from '../src/EmojiPlaceholder';

export const LazyEmojiComponentLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-srcEmojiComponent" */ '../src/EmojiComponent'))
			.EmojiComponent,
	loading: (props) => (props.emoji ? <EmojiPlaceholder {...props} /> : null),
});
